const asFiniteNumber = (value: unknown): number | undefined => {
  if (typeof value !== 'number' && (typeof value !== 'string' || value.trim() === '')) {
    return undefined
  }

  const numberValue = Number(value)

  return Number.isFinite(numberValue) ? numberValue : undefined
}

export const getProjectProgress = (project: any): number | undefined => {
  const progress = asFiniteNumber(project?.progress)

  if (progress === undefined) return undefined

  return Math.max(0, Math.min(100, progress))
}

export const getProjectMemberCount = (project: any): number | undefined => {
  if (Array.isArray(project?.users)) return project.users.length
  if (Array.isArray(project?.team?.users)) return project.team.users.length

  return undefined
}

export const getProjectTaskCount = (project: any): number | undefined => (
  Array.isArray(project?.tasks) ? project.tasks.length : undefined
)

export const formatProjectDueDate = (date?: string): string | undefined => {
  if (!date) return undefined

  const parsedDate = new Date(date)

  if (Number.isNaN(parsedDate.getTime())) return undefined

  return parsedDate.toLocaleDateString('es-PE', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).replace('.', '')
}
